export default __webpack_public_path__ + "static/media/bg.9608096e.png";